<template>
  <div class="lo_fullOverlay">
    <div class="lo_fullContainer">
      <div class="lo_pageTopBar">
        <ButtonBackArrow></ButtonBackArrow>
        <div class="pageTopBar_firstItem">Opphavsrett</div>
      </div>
      <div class="page page_copyright">
        <div class="page_content">
          <p>Prosjektleder: Ragna Marie T&oslash;rdal</p>
          <p>Redakt&oslash;r: Marion Federl</p>
          <p>
            Tekst: Oddvar Engan, Marion Federl, Ragna Marie T&oslash;rdal, Heidi
            Mobekk Solbakken, Jorunn &Oslash;veland Nyhus, Anita Ramberg
          </p>
          <p>Lisens innhold: (CC-BY-NC-SA)</p>
          <h1><strong>Bilde- og medieliste</strong></h1>
          <h2><strong>Norr&oslash;n tid</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Christian Krohg / Finn Bjorklid /
              <a
                href="https://commons.wikimedia.org/wiki/File:Christian-krohg-leiv-eriksson.jpg"
                >https://commons.wikimedia.org/wiki/File:Christian-krohg-leiv-eriksson.jpg</a
              >&nbsp;
            </li>
            <li>
              Christian Krohg / Jorunn /
              <a
                href="https://commons.wikimedia.org/wiki/File:Olav_Tryggvasons_saga_-_Harald_Graafell_-_c._Krohg.jpg"
                >https://commons.wikimedia.org/wiki/File:Olav_Tryggvasons_saga_-_Harald_Graafell_-_c._Krohg.jpg</a
              >&nbsp;
            </li>
            <li>
              Gerhard Munthe / Jorunn /
              <a
                href="https://commons.wikimedia.org/wiki/File:Olav_den_helliges_saga_GM17.jpg"
                >https://commons.wikimedia.org/wiki/File:Olav_den_helliges_saga_GM17.jpg</a
              >&nbsp;
            </li>
            <li>
              M&aring;rten Eskil Winge / Alexan /
              <a href="https://no.wikipedia.org/wiki/Fil:Thor.jpg"
                >https://no.wikipedia.org/wiki/Fil:Thor.jpg</a
              >&nbsp;
            </li>
            <li>
              Olof Ekstr&ouml;m / Maksim /
              <a
                href="https://no.wikipedia.org/wiki/Fil:Ledbergsstenen_20041231.jpg"
                >https://no.wikipedia.org/wiki/Fil:Ledbergsstenen_20041231.jpg</a
              >&nbsp;
            </li>
            <li>
              Christian Krohg / Fingalo /
              <a
                href="https://commons.wikimedia.org/wiki/File:Snorri_Sturluson_C._Krohg.jpg"
                >https://commons.wikimedia.org/wiki/File:Snorri_Sturluson_C._Krohg.jpg</a
              >&nbsp;
            </li>
            <li>
              Anker Eli Petersen: "V&ouml;lusp&aacute;" (2003) / Arne List /
              <a
                href="https://commons.wikimedia.org/wiki/File:Faroe_stamp_428_The_Prophet.jpg"
                >https://commons.wikimedia.org/wiki/File:Faroe_stamp_428_The_Prophet.jpg</a
              >&nbsp;
            </li>
            <li>
              Tiina357 /
              <a
                href="https://no.wikipedia.org/wiki/Fil:Egil_Skallagrimsson_17c_manuscript.jpg"
                >https://no.wikipedia.org/wiki/Fil:Egil_Skallagrimsson_17c_manuscript.jpg</a
              >&nbsp;
            </li>
            <li>
              Fingalo /
              <a href="https://no.wikipedia.org/wiki/Fil:CodexFrisianus.jpg"
                >https://no.wikipedia.org/wiki/Fil:CodexFrisianus.jpg</a
              >&nbsp;
            </li>
            <li>
              GDK /
              <a
                href="https://no.wikipedia.org/wiki/Fil:M%C3%B6%C3%B0ruvallab%C3%B3k_f13r.jpg"
                >https://no.wikipedia.org/wiki/Fil:M%C3%B6%C3%B0ruvallab%C3%B3k_f13r.jpg</a
              >&nbsp;
            </li>
            <li>
              Klafui / V&auml;sk /
              <a href="https://no.wikipedia.org/wiki/Fil:Overselo_Olof04.jpg"
                >https://no.wikipedia.org/wiki/Fil:Overselo_Olof04.jpg</a
              >&nbsp;
            </li>
            <li>
              Anton Sorg / Kay K&ouml;rner /
              <a
                href="https://commons.wikimedia.org/wiki/File:Tristan_and_Isolde_11.jpg"
                >https://commons.wikimedia.org/wiki/File:Tristan_and_Isolde_11.jpg</a
              >
            </li>
            <li>
              Octavio L /
              <a href="https://commons.wikimedia.org/wiki/File:Atli.jpg"
                >https://commons.wikimedia.org/wiki/File:Atli.jpg</a
              >&nbsp;
            </li>
            <li>
              Gerhard Munthe / Jorunn /
              <a
                href="https://commons.wikimedia.org/wiki/File:Magnussonnenes_saga_3_-_G._Munthe.jpg"
                >https://commons.wikimedia.org/wiki/File:Magnussonnenes_saga_3_-_G._Munthe.jpg</a
              >&nbsp;
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK&nbsp;</li>
            <li>NRK&nbsp;</li>
          </ol>
          <h2><strong>Humanisme og renessanse</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Leonardo da Vinci /Luc Viatour /
              <a
                href="https://no.wikipedia.org/wiki/Fil:Da_Vinci_Vitruve_Luc_Viatour.jpg"
                >https://no.wikipedia.org/wiki/Fil:Da_Vinci_Vitruve_Luc_Viatour.jpg</a
              >&nbsp;
            </li>
            <li>
              Leinad-Z /
              <a
                href="https://no.wikipedia.org/wiki/Fil:Cleric-Knight-Workman.jpg"
                >https://no.wikipedia.org/wiki/Fil:Cleric-Knight-Workman.jpg</a
              >&nbsp;
            </li>
            <li>
              Theodor Kittelsen: "Pesta i trappen" (1896) / WbgArchives /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Theodor_Kittelsen_-_Pesta_i_trappen,_1896_(Pesta_on_the_Stairs).jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Ukjent /
              <a href="https://en.m.wikipedia.org/wiki/File:Press_-Bettman.jpg"
                >https://en.m.wikipedia.org/wiki/File:Press_-Bettman.jpg</a
              >&nbsp;
            </li>
            <li>
              Leonardo da Vinci / Amandajm /
              <a href="http://no.wikipedia.org/wiki/Fil:Mona_Lisa.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Jan Matejko / EugeneZelenko /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Jan_Matejko-Astronomer_Copernicus-Conversation_with_God.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / CTSWyneken /
              <a href="http://commons.wikimedia.org/wiki/File:Luther46c.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Hieronymus Scholeus / Nina-no /
              <a href="http://no.wikipedia.org/wiki/Fil:Scoleus.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / K&aring;re-Olav /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Diplomatarium_Norvegicum_I_409.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
            <li>DialektXperten&nbsp;</li>
            <li>Ellen Kalvenes / Kristin Eriksen Vold / NDLA</li>
          </ol>
          <h2><strong>Barokk</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Dirk van der Made / DirkvdM /
              <a
                href="http://commons.wikimedia.org/wiki/File:Orgel_Oude_Kerk.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Nicolas de Largilli&egrave;re / Eloquence /
              <a
                href="http://commons.wikimedia.org/wiki/File:Nicolas_de_Largilli%C3%A8re_003.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Saddhiyama /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Frederik_3_by_window.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ranveig /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Tittelkobberet_p%C3%A5_f%C3%B8rsteutgaven_av_Dorothe_Engelbretsdatters_bok_Taare-Offer,_1685..jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Dirk van der Made / DirkvdM /
              <a
                href="http://commons.wikimedia.org/wiki/File:Orgel_Oude_Kerk.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Michelangelo Caravaggio / Eloquence /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Michelangelo_Caravaggio_038.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Elias Gottlob Haussmann: Johann Sebastian Bach (1748) / Clavecin /
              <a href="http://commons.wikimedia.org/wiki/File:Bach.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Phrood /
              <a href="https://commons.wikimedia.org/wiki/File:Vivaldi.jpg"
                >https://commons.wikimedia.org/wiki/File:Vivaldi.jpg</a
              >&nbsp;
            </li>
            <li>
              Ukjent / Ranveig /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Tittelkobberet_p%C3%A5_f%C3%B8rsteutgaven_av_Dorothe_Engelbretsdatters_bok_Taare-Offer,_1685..jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Arne List /
              <a href="http://no.wikipedia.org/wiki/Fil:Thomas_kingo.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Bjaespb /
              <a href="http://no.wikipedia.org/wiki/Fil:Dorothe.gif"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              John Lerli / Ranveig /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Petter_Dass_i_Melhus.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Thuresson /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Bible_of_Christian_III_1550.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              NicvK / Diligent /<a
                href="http://no.wikipedia.org/wiki/Fil:Bernini_Baldachino.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Eloquence /
              <a
                href="https://no.wikipedia.org/wiki/Fil:Peter_Paul_Rubens_101.jpg"
                >https://no.wikipedia.org/wiki/Fil:Peter_Paul_Rubens_101.jpg</a
              >&nbsp;
            </li>
            <li>
              Nina-no /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Santa_Maria_della_Vittoria_-_7.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>Arne Torp / DialektXperten&nbsp;</li>
          </ol>
          <h2><strong>Opplysningstid</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Ragesoss /
              <a
                href="http://en.wikipedia.org/wiki/File:Voltaire_Philosophy_of_Newton_frontispiece.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Jean-Pierre Hou&euml;l: "Stormen p&aring; Bastillen" (1789) / Dodo
              /
              <a
                href="http://fr.wikipedia.org/wiki/Fichier:Prise_de_la_Bastille.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              GodfreyKneller: IsaacNewton (1689) / Zaphod /
              <a
                href="http://no.wikipedia.org/wiki/Fil:GodfreyKneller-IsaacNewton-1689.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Beno&icirc;t Louis Pr&eacute;vost: Forsats til Encyclopedien /
              Tomisti /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Encyclopedie_frontispice_full_473px.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Stefan Bauer / Ferras /
              <a
                href="http://en.wikipedia.org/wiki/File:Villa_Rotonda_front.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Franz Gustav Forsmann /Wolfgang Meinhart / Wmeinhart /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Hamburg.Jenischhaus.wmt.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              J&oslash;rgen Roed: Ludvig Holberg (1847) / Orland /
              <a href="http://no.wikipedia.org/wiki/Fil:JRoed_Holberg_1947.JPG"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Eilif Peterssen: "En Aften i Det norske Selskab (1892) / Mahlum /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Norske_Selskab_Eilif_Peterssen.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Antoine Watteau: "Pilgrimage to Cythera" (1721) / Eloquence /
              <a
                href="http://en.wikipedia.org/wiki/File:Antoine_Watteau_035.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Johann Nepomuk della Croce: "Wolfgang Amadeus Mozart mit Schwester
              Maria Anna und Vater Leopold, an der Wand ein Portrait der
              verstorbenen Mutter, Anna Maria" (ca. 1780) / Moby Dick /
              <a href="http://commons.wikimedia.org/wiki/File:Wolfgang01.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Thomas Hardy: Joseph Haydn (17929 / Adam /
              <a
                href="http://commons.wikimedia.org/wiki/File:Haydn_portrait_by_Thomas_Hardy_(small).jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Joseph Karl Stieler: "Portrait Ludwig van Beethoven when composing
              the Missa Solemnis" (1820) / ADGE /
              <a href="http://commons.wikimedia.org/wiki/File:Beethoven.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>NRK</li>
            <li>NRK</li>
            <li>DialektXperten</li>
            <li>DialektXperten</li>
          </ol>
          <h2><strong>Romantikk</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Caspar David Friedrich: "Der Wanderer &uuml;ber dem Nebelmeer"
              (1818), utsnitt / Augiasstallputzer /
              <a
                href="http://commons.wikimedia.org/wiki/File:Caspar_David_Friedrich_032_High_Resolution.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Oscar Wergeland: "Riksforsamlingen p&aring; Eidsvoll 1814" (1885)
              / Magnus Manske /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Eidsvoll_riksraad_1814.jpeg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Adolph Tidemand: "Norsk juleskik" (1846) / Orland /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Adolph_Tidemand_Norsk_juleskik.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Lars Hertervig: "Skogtjern" (1865) / Eloquence /
              <a href="http://no.wikipedia.org/wiki/Fil:Lars_Hertervig_001.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              I.C. Dahl: "Bjerk i storm" (1849) / Agtfjott /
              <a
                href="http://no.wikipedia.org/wiki/Fil:ICDahl,_Bjerk_i_storm.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Theodor Kittelsen: "Trollet som grunner p&aring; hvor gammelt det
              er" (1911) / Samuelsen /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Trollet_som_grunner_p%C3%A5_hvor_gammelt_det_er.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Mahlum /
              <a href="http://no.wikipedia.org/wiki/Fil:Huldreeventyr2.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Ukjent /
              <a
                href="http://commons.wikimedia.org/wiki/File:H_C_Andersen_storyteller.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Carl Peter Lehmann: Henrik Wergeland (1842) / Orland /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Lehmann_Wergeland_1842.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Carl Peter Lehmann: Johan Welhaven(1842) / Orland /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Lehmann_J_Welhaven_1842.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Axel Theodor Lindahl: Universitetet i Oslo / Kjetil r /
              <a href="http://commons.wikimedia.org/wiki/File:Lindahl_UiO.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Caspar David Friedrich: "Der Wanderer &uuml;ber dem Nebelmeer"
              (1818) / Augiasstallputzer /
              <a
                href="http://commons.wikimedia.org/wiki/File:Caspar_David_Friedrich_032_High_Resolution.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Adolph Tidemand: "Brudeferden i Hardanger" (1848) / Orland /
              <a href="http://no.wikipedia.org/wiki/Fil:Brudeferden.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Litografi fra Almanach der Musikgesellschaft", Zurich 1834 / Kokin
              /
              <a
                href="http://commons.wikimedia.org/wiki/File:Beethoven_AlmanachDerMusikgesellschaft_1834.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Josef Kriehuber: Franz Schubert / Raul654 /
              <a
                href="http://commons.wikimedia.org/wiki/File:Franz_Schubert.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Nico-dk /
              <a href="http://commons.wikimedia.org/wiki/File:Schuhmann.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Nicola Perscheid: Edvard Grieg (1905) / Lupo /
              <a
                href="http://commons.wikimedia.org/wiki/File:Edvard_Grieg_by_Perscheid_1905.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>Arne Torp / DialektXperten</li>
          </ol>
          <h2>
            <strong>Realisme, naturalisme og det moderne gjennombruddet</strong>
          </h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Christian Krohg: "Albertine i politil&aelig;gens
              ventev&aelig;relse" (1887) / Nasjonalmuseet/Lathion, Jacques/
              <a
                href="https://www.nasjonalmuseet.no//en/collection/object/NG.M.00776"
                >https://www.nasjonalmuseet.no//en/collection/object/NG.M.00776</a
              >&nbsp;
            </li>
            <li>
              Eug&egrave;ne Delacroix: "La libert&eacute; guidant le peuple"
              (1830) / Crisco /
              <a
                href="https://commons.wikimedia.org/wiki/File:Eug%C3%A8ne_Delacroix_-_La_libert%C3%A9_guidant_le_peuple.jpg"
                >https://commons.wikimedia.org/wiki/File:Eug%C3%A8ne_Delacroix_-_La_libert%C3%A9_guidant_le_peuple.jpg</a
              >&nbsp;
            </li>
            <li>
              Loos, F / Arbeiderbevegelsens arkiv og bibliotek /
              <a
                href="https://digitaltmuseum.no/011012602637/tekstilfabrikker-ved-akerselva-i-forgrunnen-nedre-voien-spinderi-oppfort"
                >https://digitaltmuseum.no/011012602637/tekstilfabrikker-ved-akerselva-i-forgrunnen-nedre-voien-spinderi-oppfort</a
              >&nbsp;
            </li>
            <li>
              Chr. T&oslash;nsberg (1848) / Frode Inge Helland /
              <a href="http://no.wikipedia.org/wiki/Fil:Arendal035.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Ukjent (utsnitt) / Chnodomar /
              <a href="http://no.wikipedia.org/wiki/Fil:Maerz1848_berlin.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Katharina /
              <a
                href="http://de.wikipedia.org/w/index.php?title=Datei:Help_us_to_win_the_vote.jpg&amp;filetimestamp=20040121224435"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Aegis Maelstrom /
              <a href="http://commons.wikimedia.org/wiki/File:Auguste_Comte.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Bob Burkhardt /
              <a href="http://commons.wikimedia.org/wiki/File:Karl_Marx.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              James Tassle (1787) / Protonk /
              <a href="http://commons.wikimedia.org/wiki/File:AdamSmith.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              John Watkins (1865) / Scewing /
              <a
                href="http://en.wikipedia.org/wiki/File:John_Stuart_Mill_by_John_Watkins,_1865.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Niels Christian Kierkegaard (ca. 1840) / Joonasi /
              <a href="http://commons.wikimedia.org/wiki/File:Kierkegaard.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              John G. Murdoch (ca. 1874) / Ragesoss /
              <a
                href="http://commons.wikimedia.org/wiki/File:Darwin_-_John_G_Murdoch_Portrait_restored.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Hartmann (ca. 1875) / Anton /
              <a href="http://commons.wikimedia.org/wiki/File:Nietzsche187a.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Christian Krohg: "H&aring;ret flettes" (1882) / Eloquence /
              <a
                href="http://commons.wikimedia.org/wiki/File:Christian_Krohg_001.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              <a
                href="https://commons.wikimedia.org/wiki/User:Anne-Sophie_Ofrim"
                >Anne-Sophie Ofrim</a
              >
              /
              <a
                href="https://commons.wikimedia.org/wiki/File:Eilert_Sundt_OB.00326.jpg"
                >https://commons.wikimedia.org/wiki/File:Eilert_Sundt_OB.00326.jpg</a
              >
            </li>
            <li>
              Ukjent / Mahlum /
              <a href="http://commons.wikimedia.org/wiki/File:Vinje.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Johan G&oslash;rbitz (1839) / Orland /
              <a
                href="http://commons.wikimedia.org/wiki/File:Camilla_Collett_1839.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Peter Nicolai Arbo (1896) / Jorunn /
              <a href="http://commons.wikimedia.org/wiki/File:Arbo-Per_Gynt.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Hugo Edlund eller Arthur Thorell (1919) / FredrikT /
              <a
                href="http://commons.wikimedia.org/wiki/File:Eide_och_Hanson_i_Synn%C3%B6ve_Solbakken_1919.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Christian Krohg: "Kampen for tilv&aelig;relsen" (1889) / Blacklake
              /
              <a
                href="http://commons.wikimedia.org/wiki/File:Christian_Krohg-Kampen_for_tilv%C3%A6relsen_1889.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Gustav Borgen (1900) / DionysosProteus /
              <a
                href="http://commons.wikimedia.org/wiki/File:Ibsen-by-Bergen.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              <a
                href="https://commons.wikimedia.org/w/index.php?title=User:%D0%A1%D1%8D%D1%80_%D0%94%D0%B6%D0%BE%D0%BD&amp;action=edit&amp;redlink=1"
                >Сэр Джон</a
              >
              /
              <a
                href="https://commons.wikimedia.org/wiki/File:3_Hedvig.jpg?uselang=nb"
                >https://commons.wikimedia.org/wiki/File:3_Hedvig.jpg?uselang=nb</a
              >
            </li>
            <li>
              Karl Anderson (1904) / K&aring;re-Olav /
              <a
                href="http://commons.wikimedia.org/wiki/File:Bj%C3%B8rnstjerne_Bj%C3%B8rnson_by_Karl_Anderson_1904.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Kjetil r /
              <a href="http://sv.wikipedia.org/wiki/Fil:Kielkopi.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent (1908) / Nico-dk /
              <a
                href="http://commons.wikimedia.org/wiki/File:Jonas_Lie_ITokt1908.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Christian Krohg: "Albertine" (1884) / Dittaeva /
              <a
                href="http://nn.wikipedia.org/wiki/Fil:Christian_Krogh_-_Albertine.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              &Eacute;mile Fran&ccedil;ois Zola: Selvportrett (1902) / Van
              Nuytts /
              <a href="http://commons.wikimedia.org/wiki/File:ZOLA_1902B.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Ukjent / Bisgaard /
              <a href="http://commons.wikimedia.org/wiki/File:Amalie_Skram2.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Ranveig /
              <a
                href="http://commons.wikimedia.org/wiki/File:Garborg_portrett.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              <a
                href="https://digitaltmuseum.no/search/?aq=name%3A%22377898AD-8EE1-48E1-8D22-DFFE1DD2AF4C%22"
                >Marschalk, Max</a
              >
              /Norsk Teknisk Museum
              <a
                href="https://digitaltmuseum.no/021016118357/edvard-munch-portrett-av-hans-jaeger"
                >https://digitaltmuseum.no/021016118357/edvard-munch-portrett-av-hans-jaeger</a
              >&nbsp;
            </li>
            <li>
              Martin Finborud / Torstein /
              <a
                href="http://commons.wikimedia.org/wiki/File:Christian_Krogh.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Hartmut Reiche / BArchBot /
              <a
                href="http://commons.wikimedia.org/wiki/File:Bundesarchiv_Bild_183-1983-1118-005,_Berlin,_%22Gespenster%22.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>Kvensk institutt</li>
            <li>
              Arne Garborg (1888) / V85 /
              <a
                href="http://commons.wikimedia.org/w/index.php?title=File:Norsk_eller_Dansk-Norsk.djvu&amp;page=1"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Carl Christian Wischmann (1881) / Mahlum /
              <a
                href="http://commons.wikimedia.org/wiki/File:Aasen_Wischmann_1881.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Rart /
              <a href="http://no.wikipedia.org/wiki/Fil:Knudknudsen.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Chr. Krogh: "Albertine i politil&aelig;gens ventev&aelig;relse"
              (1887), utsnitt / Eikern /
              <a
                href="http://commons.wikimedia.org/wiki/File:Christian_Krogh-Albertine_i_politil%C3%A6gens_ventev%C3%A6relse2.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Claude Monet: "Impression, soleil levant" (1872) / Luestling /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Claude_Monet,_Impression,_soleil_levant,_1872.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Peder Severin Kr&oslash;yer: "Hip, hip hurra! Kunstnerfest
              p&aring; Skagen" (1888) / Thuresson /
              <a
                href="http://no.wikipedia.org/wiki/Fil:PS_Kr%C3%B8yer_-_Hip_hip_hurra!_Kunstnerfest_p%C3%A5_Skagen_1888.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Nicola Perscheid: Edvard Grieg (1905) / Lupo /
              <a
                href="http://commons.wikimedia.org/wiki/File:Edvard_Grieg_by_Perscheid_1905.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Nina Aldin Thune / Nina-no /
              <a href="http://no.wikipedia.org/wiki/Fil:Kviknebalestrand.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h2><strong>Nyromantikk og tidlig modernisme</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Harald Sohlberg: "Vinternatt" (1914) / Jt68 /
              <a href="http://no.wikipedia.org/wiki/Fil:Vinternatt.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Sigvard Heber (ca. 1907) / Kjetil r /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Bergensbanen-sammenkobling-1907.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Henri de Toulouse-Lautrec: "La Goulue arrivant au Moulin Rouge"
              (1892) / High on a tree /
              <a
                href="http://commons.wikimedia.org/wiki/File:Toulouse-Lautrec_-_La_Goulue_arrivant_au_Moulin_Rouge.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Max Halberstadt (1922) / Lobo /
              <a
                href="http://commons.wikimedia.org/wiki/File:Sigmund_Freud_LIFE.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Hans Olde (ca. 1899) / Berteun /
              <a
                href="http://commons.wikimedia.org/wiki/File:Friedrich_Nietzsche_drawn_by_Hans_Olde.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Lampman /
              <a href="http://commons.wikimedia.org/wiki/File:Gabriel_Scott.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Harald Brun (1908) / Orland /
              <a
                href="http://commons.wikimedia.org/wiki/File:Hans_E_Kinck_av_Harald_Brun_1908.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Achim Raschka /
              <a
                href="http://commons.wikimedia.org/wiki/File:Knut_hamsun_1890.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Nikolai Astrup: "Maim&aring;ne", utsnitt / Jorunn /
              <a
                href="http://en.wikipedia.org/wiki/File:N_Astrup-Maim%C3%A5ne.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Vincent van Gogh: Selvportrett foran staffeliet" (1888) /
              Eloquence /
              <a
                href="http://commons.wikimedia.org/wiki/File:Vincent_Willem_van_Gogh_111.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Anders Beer Wilse (1919) / Manxruler /
              <a
                href="http://commons.wikimedia.org/wiki/File:Nordahl_Rolfsen.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Norman Bruderhofer / Phonatic /
              <a
                href="http://de.wikipedia.org/w/index.php?title=Datei:VictorVPhonograph.jpg&amp;filetimestamp=20061025081720"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Anders Beer Wilse (1912) / Manxruler /
              <a
                href="http://commons.wikimedia.org/wiki/File:Edvard_Munch_1912.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Nicola Perscheid: Edvard Grieg (1905) / Lupo /
              <a
                href="http://commons.wikimedia.org/wiki/File:Edvard_Grieg_by_Perscheid_1905.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Magnus Manske /
              <a
                href="https://commons.wikimedia.org/wiki/File:Piano_Concerto_in_A_minor_Op._16_(Grieg);_Allegro_molto_moderato.JPG"
                >https://commons.wikimedia.org/wiki/File:Piano_Concerto_in_A_minor_Op._16_(Grieg);_Allegro_molto_moderato.JPG</a
              >&nbsp;
            </li>
            <li>
              Ukjent / Pladask /
              <a
                href="http://commons.wikimedia.org/wiki/File:Christian_Sinding.jpeg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Karl Anton Nyblin / Emerson7 /
              <a
                href="http://commons.wikimedia.org/wiki/File:Johan_Halvorsen.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Lobo /
              <a
                href="http://commons.wikimedia.org/wiki/File:Claude_Debussy_1900.jpeg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Alfred Wagon / Siren-Com /
              <a
                href="http://en.wikipedia.org/wiki/File:Immeuble_rue_de_l%27%C3%A9glise_d%C3%A9tail_Porte.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Tony Hall / David40226543 /
              <a
                href="https://no.m.wikipedia.org/wiki/Fil:Jugendstilsenteret.jpg"
                >https://no.m.wikipedia.org/wiki/Fil:Jugendstilsenteret.jpg</a
              >&nbsp;
            </li>
          </ol>
          <h2><strong>Nyrealisme og modernisme</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Arkivfoto Scanpix Sverige / CC BY-NC-SA</li>
            <li>
              Ukjent / Kjetil r /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Kong_Haakon_ankommer_Norge_1905.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>NRK</li>
            <li>
              Ukjent / Manxruler /
              <a
                href="http://en.wikipedia.org/wiki/File:Ida_Cecilie_Thoresen_Krog.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ilya Repin: "Demonstration on October 17" (1906) / QWerk /
              <a
                href="http://commons.wikimedia.org/wiki/File:Demonstration_on_October_17,_1905_by_Ilya_Repin_(adumbration_1906).jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>The Granger Collection / NTB scanpix / CC BY-NC-SA</li>
            <li>NTB arkiv / Scanpix / CC BY-NC-SA</li>
            <li>
              Oren Jack Turner / Lupo /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Albert_Einstein_Head.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Olav Bjaaland / Bikeable /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Aan_de_Zuidpool_-_p1913-160.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>K&aring;re Nymark / Aktuell / Scanpix / CC BY-NC-SA</li>
            <li>Trygve Indrelid / Scanpix / CC BY-NC-SA</li>
            <li>
              Anders Beer Wilse: "Knut Hamsun p&aring; stranden" (1914) /
              Deadstar /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Knut_Hamsun,_by_Anders_Beer_Wilse.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Alvilde Torp / Sandivas /
              <a
                href="http://en.wikipedia.org/wiki/File:Sigrid_Undset_at_Bjerkeb%C3%A6k.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Aage Storl&oslash;kken / Aktuell / Scanpix / CC BY-NC-SA</li>
            <li>Gisle Oddstad / Scanpix / CC BY-NC-SA</li>
            <li>
              Harald Sohlberg: "Vinternatt" (1914) / Jt68 /
              <a href="http://no.wikipedia.org/wiki/Fil:Vinternatt.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>NTB arkiv / Scanpix / CC BY-NC-SA</li>
            <li>
              Anders Beer Wilse / K&aring;re-Olav /
              <a href="http://no.wikipedia.org/wiki/Fil:Olaf_Bull_1919.jpeg"
                >Wikimedia Commons</a
              >
            </li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>
              Knut Liest&oslash;l / K&aring;re-Olav /
              <a href="http://en.wikipedia.org/wiki/File:Moltke_Moe.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>Posten Norge / Scanpix / CC BY-NC-SA</li>
            <li>NRK</li>
            <li>NTB arkiv / Scanpix / CC BY-NC-SA</li>
            <li>NRK</li>
            <li>
              Holger Ellgaard / Holger.Ellgaard /
              <a
                href="http://commons.wikimedia.org/wiki/File:Kristallradio.JPG?uselang=sv"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              JuanGris: "Portrait of Picasso" (1912) / Ahellwig /
              <a
                href="http://en.wikipedia.org/wiki/File:JuanGris.Portrait_of_Picasso.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Wyndham Lewis: "Blast" forside (1915) / Lukius /
              <a href="http://no.wikipedia.org/wiki/Fil:Blast2.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Marcel Duchamp: "Fountain" (1917) / Progettualita /
              <a href="http://en.wikipedia.org/wiki/File:Duchamp_Fountaine.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              P.V. Jensen-Klint: Grundtvig Memorial Church / Mahlum /
              <a
                href="http://en.wikipedia.org/wiki/File:Pv_jensen-klint_05_grundtvig_memorial_church_1913-1940.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Florence Homolka (ca. 1848) / Kelson /
              <a
                href="http://en.wikipedia.org/wiki/File:Arnold_Schoenberg_la_1948.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent (1953) / Calliopejen1 /
              <a
                href="http://en.wikipedia.org/wiki/File:Louis_Armstrong_restored.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK&nbsp;</li>
            <li>Terranova</li>
          </ol>
          <h2><strong>Modernisme og realisme</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              AFBorchert /
              <a
                href="https://commons.wikimedia.org/wiki/File:Mural_del_Gernika.jpg"
                >https://commons.wikimedia.org/wiki/File:Mural_del_Gernika.jpg</a
              >&nbsp;
            </li>
            <li>NTB Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>NTB Scanpix / CC BY-NC-SA</li>
            <li>
              Sverre A. B&oslash;rretzen / Aktuell / Scanpix / CC BY-NC-SA
            </li>
            <li>Aktuell / Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>The Granger Collecton / NTB / CC BY-NC&nbsp;</li>
            <li>
              Gustav-Adolf Schultze /
              <a
                href="https://commons.wikimedia.org/wiki/File:Nietzsche1882.jpg"
                >https://commons.wikimedia.org/wiki/File:Nietzsche1882.jpg</a
              >
            </li>
            <li>
              DcoetzeeBot /
              <a
                href="https://en.wikipedia.org/wiki/File:Vasily_Perov_-_%D0%9F%D0%BE%D1%80%D1%82%D1%80%D0%B5%D1%82_%D0%A4.%D0%9C.%D0%94%D0%BE%D1%81%D1%82%D0%BE%D0%B5%D0%B2%D1%81%D0%BA%D0%BE%D0%B3%D0%BE_-_Google_Art_Project.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>
              <a href="https://en.wikipedia.org/wiki/User:Wandering_Courier"
                >Wandering Courier</a
              >
              /
              <a
                href="https://en.wikipedia.org/wiki/File:Gabriel_Marcel_(c._1951).jpg"
                >https://en.wikipedia.org/wiki/File:Gabriel_Marcel_(c._1951).jpg</a
              >&nbsp;
            </li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA &nbsp;</li>
            <li>
              <a href="https://commons.wikimedia.org/wiki/User:Gorupdebesanez"
                >Gorupdebesanez</a
              >
              /
              <a
                href="https://commons.wikimedia.org/wiki/File:Eugene_Ionesco_01.jpg"
                >https://commons.wikimedia.org/wiki/File:Eugene_Ionesco_01.jpg</a
              >
            </li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Thor Nielsen / VG / Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Aage Storl&oslash;kken / Scanpix / CC BY-NC-SA&nbsp;</li>
            <li>Rolf Chr. Ulrichsen / Aftenposten /Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>
              Aage Storl&oslash;kken / Aktuell / Scanpix / CC BY-NC-SA&nbsp;
            </li>
            <li>Scanpix / CC BY-NC-SA&nbsp;</li>
            <li>Arkivfoto / NTB. CC BY-NC</li>
            <li>
              Aage Storl&oslash;kken / Aktuell / Scanpix / CC BY-NC-SA&nbsp;
            </li>
            <li>Knut Snare / Aftenposten /Scanpix / CC BY-NC-SA</li>
            <li>Tom A. Kolstad / Scanpix / CC BY-NC-SA</li>
            <li>John Myhre / Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>Aktuell / Scanpix / CC BY-NC-SA</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>NTB arkiv / UPI / Scanpix / CC BY-NC-SA</li>
            <li>NTB arkiv / Scanpix / CC BY-NC-SA</li>
            <li>
              Ukjent /
              <a href="https://commons.wikimedia.org/wiki/User:Maxim75"
                >Maxim75</a
              >
              /
              <a
                href="https://commons.wikimedia.org/wiki/File:Nazi_Germany_NSDAP_poster.jpg"
                >https://commons.wikimedia.org/wiki/File:Nazi_Germany_NSDAP_poster.jpg</a
              >&nbsp;
            </li>
            <li>
              <a href="https://commons.wikimedia.org/wiki/User:Arek1979"
                >Arek1979</a
              >
              /
              <a
                href="https://commons.wikimedia.org/wiki/File:German_antisemitic_poster,_1942.jpg"
                >https://commons.wikimedia.org/wiki/File:German_antisemitic_poster,_1942.jpg</a
              >&nbsp;
            </li>
            <li>Rolf M. Aagaard / Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>Rolf M. Aagaard / BONO / Scanpix</li>
            <li>Rolf Chr. Ulrichsen / Scanpix / CC BY-NC-SA</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>
              Sverre A. B&oslash;rretzen / Aktuell / Scanpix / CC BY-NC-SA
            </li>
            <li>AP / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>NRK</li>
            <li>NRK Skole</li>
            <li>NRK Skole</li>
            <li>NRK Skole</li>
            <li>NRK Skole</li>
            <li>NRK Skole</li>
            <li>NRK Skole&nbsp;</li>
          </ol>
          <h2><strong>Postmodernisme og realisme&nbsp;</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Heiko Junge / NTB / CC BY-NC</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Henry Diltz / Corbis / Scanpix&nbsp;</li>
            <li>Jan A. Martinsen / Aftenposten / Scanpix / NTB / CC BY-NC</li>
            <li>Bettmann/Corbis/Scanpix / CC BY-NC-SA</li>
            <li>Aftenposten/Scanpix / NTB / CC BY-NC</li>
            <li>Carmen Taylor / AP / Scanpix / CC BY-NC-SA</li>
            <li>Kerstin Mertens / Samfoto / Scanpix /&nbsp;</li>
            <li>Vegard Gr&oslash;tt / NTB Scanpix / CC BY-NC-SA</li>
            <li>
              Bracha L. Ettinger /
              <a
                href="https://commons.wikimedia.org/wiki/File:Jean-Francois_Lyotard_cropped.jpg"
                >https://commons.wikimedia.org/wiki/File:Jean-Francois_Lyotard_cropped.jpg</a
              >&nbsp;
            </li>
            <li>Marit Hommedal / Scanpix / CC BY-NC-SA</li>
            <li>Nelson Almeida / AFP / Scanpix</li>
            <li>Henrik Laurvik / NTB Scanpix / CC BY-NC-SA</li>
            <li>H&aring;kon Mosvold Larsen / NTB /CC BY-NC</li>
            <li>Rolf M. Aagaard / NTB Scanpix / CC BY-NC-SA</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Olav Olsen / Aftenposten /Scanpix / CC BY-NC-SA</li>
            <li>Berit Roald / NTB /CC BY-NC</li>
            <li>
              Bep /
              <a
                href="https://commons.wikimedia.org/wiki/File:Einar_%C3%98kland_@_Oslo_bokfestival_2011.jpg"
                >https://commons.wikimedia.org/wiki/File:Einar_%C3%98kland_@_Oslo_bokfestival_2011.jpg</a
              >&nbsp;
            </li>
            <li>Kyrre Lien / NTB / CC BY-NC</li>
            <li>Berit Roald / NTB / CC BY-NC</li>
            <li>Terje Bendiksby / NTB / CC BY-NC</li>
            <li>Helle Aasand, VG&nbsp;</li>
            <li>Svein Erik Dahl / Samfoto / Scanpix / CC BY-NC-SA</li>
            <li>Bj&oslash;rn Berg / NTB / CC BY-NC</li>
            <li>
              Bep /
              <a
                href="https://commons.wikimedia.org/wiki/File:Tove_Nilsen_at_Oslo_bokfestival_2012.jpg"
                >https://commons.wikimedia.org/wiki/File:Tove_Nilsen_at_Oslo_bokfestival_2012.jpg</a
              >&nbsp;
            </li>
            <li>
              Herdis Maria Siegert / Aschehoug /
              <a href="https://aschehoug.no/Anne-Karin_Elstad"
                >https://aschehoug.no/Anne-Karin_Elstad</a
              >
              Copyright
            </li>
            <li>
              F&aelig; / Johannes Jansson/norden.org /
              <a
                href="https://commons.wikimedia.org/wiki/File:Den_norska_forfattaren_Herbjorg_Wassmo_vid_ett_litteraturseminarium_i_Oslo_2011-04-11_(4).jpg"
                >https://commons.wikimedia.org/wiki/File:Den_norska_forfattaren_Herbjorg_Wassmo_vid_ett_litteraturseminarium_i_Oslo_2011-04-11_(4).jpg</a
              >&nbsp;
            </li>
            <li>
              Jarvin /
              <a
                href="https://commons.wikimedia.org/wiki/File:Kjartan_Fl%C3%B8gstad.jpg"
                >https://commons.wikimedia.org/wiki/File:Kjartan_Fl%C3%B8gstad.jpg</a
              >&nbsp;
            </li>
            <li>Paul Owesen / NTB Scanpix / CC BY-NC-SA</li>
            <li>Nils Bj&aring;land / VG / NTB / CC BY-NC</li>
            <li>
              <a
                href="https://bilder.ntb.no/r/?mainGroup=editorial&amp;photographer=Stian%20Lysberg%20Solum"
                >Stian Lysberg Solum</a
              >
              / NTB / CC BY-NC
            </li>
            <li>Morten L&oslash;berg / Samfoto / NTB / CC BY-NC</li>
            <li>Berit Roald / Cappelen Damm / NTB / CC BY-NC</li>
            <li>Marte Christensen /NTB / CC BY-NC</li>
            <li>Heiko Junge / Scanpix / CC BY-NC-SA</li>
            <li>Cornelius Poppe / NTB / CC BY-NC</li>
            <li>Simon Nyhus</li>
            <li>Ingar Storfjell / Aftenposten / NTB / CC BY-NC</li>
            <li>Carl Martin Nordby / Scanpix / CC BY-NC-SA</li>
            <li>Rolf &Oslash;hman / Scanpix / CC BY-NC-SA</li>
            <li>
              Mattis Folkestad / NRK P3 /
              <a
                href="https://www.flickr.com/photos/nrk-p3/37759679532/in/photostream/"
                >https://www.flickr.com/photos/nrk-p3/37759679532/in/photostream/</a
              >&nbsp;
            </li>
            <li>Erlend Aas / NTB / CC BY-NC</li>
            <li>
              <a
                href="https://commons.wikimedia.org/w/index.php?title=User:ChrissKockelmann&amp;action=edit&amp;redlink=1"
                >Christoph Kockelmann</a
              >
              /
              <a
                href="https://commons.wikimedia.org/wiki/File:Jostein_Gaarder_2019,_3Sat_Interview_auf_der_Frankfurter_Buchmesse.jpg"
                >https://commons.wikimedia.org/wiki/File:Jostein_Gaarder_2019,_3Sat_Interview_auf_der_Frankfurter_Buchmesse.jpg</a
              >&nbsp;
            </li>
            <li>H&aring;kon Mosvold Larsen / Scanpix / CC BY-NC-SA</li>
            <li>Trygve Indrelid / Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>Berit Roald / NTB / CC BY-NC</li>
            <li>
              Mewasul /
              <a
                href="https://commons.wikimedia.org/wiki/File:TrudeMarstein.jpg"
                >https://commons.wikimedia.org/wiki/File:TrudeMarstein.jpg</a
              >&nbsp;
            </li>
            <li>H&aring;kon Mosvold Larsen / NTB / CC BY-NC</li>
            <li>Lise &Aring;serud / NTB / CC BY-NC</li>
            <li>Nina Kammersten / CC BY-NC</li>
            <li>Erlend Aas / Scanpix / CC BY-NC-SA</li>
            <li>Tore Meek / Scanpix / CC BY-NC-SA</li>
            <li>Knut Falch / Scanpix / CC BY-NC-SA</li>
            <li>Erik Berglund / Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>Bj&oslash;rn Reese / VG / Scanpix&nbsp;</li>
            <li>Nelson Almeida / AFP / Scanpix&nbsp;</li>
            <li>
              <a
                href="https://commons.wikimedia.org/w/index.php?title=User:Johansen1&amp;action=edit&amp;redlink=1"
                >Johansen1</a
              >
              /
              <a
                href="https://commons.wikimedia.org/wiki/File:Pushwagner_-_B%C3%A6rum_Kunstforening.jpg"
                >https://commons.wikimedia.org/wiki/File:Pushwagner_-_B%C3%A6rum_Kunstforening.jpg</a
              >&nbsp;
            </li>
            <li>Mimsy M&oslash;ller / Samfoto / NTB&nbsp;</li>
            <li>
              <a
                href="https://commons.wikimedia.org/w/index.php?title=User:Stryngford&amp;action=edit&amp;redlink=1"
                >Stryngford</a
              >
              /
              <a
                href="https://commons.wikimedia.org/wiki/File:Kjartan_Slettemark,_Stockholm_2006.jpg"
                >https://commons.wikimedia.org/wiki/File:Kjartan_Slettemark,_Stockholm_2006.jpg</a
              >&nbsp;
            </li>
            <li>NTB / CC BY-NC-SA</li>
            <li>
              Jim Pietryga /
              <a
                href="https://commons.wikimedia.org/wiki/File:The_Rolling_Stones_Summerfest_in_Milwaukee_-_2015.jpg"
                >https://commons.wikimedia.org/wiki/File:The_Rolling_Stones_Summerfest_in_Milwaukee_-_2015.jpg</a
              >
            </li>
            <li>Knut Snare / Aftenposten / NTB</li>
            <li>Knut Fjeldstad / Scanpix / CC BY-NC-SA</li>
            <li>Mimsy M&oslash;ller / Samfoto / Scanpix / CC BY-NC-SA</li>
            <li>Erik Norrud / Dagsavisen / Samfoto / NTB / CC BY-NC</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
            <li>NRK</li>
            <li>NRK Skole</li>
            <li>NRK</li>
            <li>NRK</li>
            <li>NRK</li>
            <li>NRK Skole</li>
          </ol>
          <h1><strong>B&Oslash;KER</strong></h1>
          <h2><strong>Beowulf</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              EugeneZelenko /
              <a href="http://en.wikipedia.org/wiki/File:Beowulf.firstpage.jpeg"
                >Wikimedia Commons</a
              >
            </li>
            <li>Warner Bros. / filmweb.no</li>
            <li>
              J.R. Skelton (1908) / Berig /
              <a
                href="http://en.wikipedia.org/wiki/File:Beowulf_and_the_dragon.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Mararie / Thuresson /
              <a
                href="http://sv.wikipedia.org/wiki/Fil:Helmet_from_a_7th_century_boat_grave,_Vendel_era.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Frederico Barocci: "Aeneas' Flight from Troy" (1598) /
              AndreasPraefcke /
              <a href="http://no.wikipedia.org/wiki/Fil:BarocciAeneas.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>British Library</li>
          </ol>
          <h2><strong>Den eldre Edda</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Anker Eli Petersen: "V&ouml;lusp&aacute;" (2003) / Arne List /
              <a
                href="https://commons.wikimedia.org/wiki/File:Faroe_stamp_428_The_Prophet.jpg"
                >https://commons.wikimedia.org/wiki/File:Faroe_stamp_428_The_Prophet.jpg</a
              >&nbsp;
            </li>
            <li>
              M&aring;rten Eskil Winge: "Thors strid med j&auml;ttarna" (1872) /
              Alexan /
              <a href="http://no.wikipedia.org/wiki/Fil:Thor.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              G. Collingwood "The Stranger at the Door" (1908) / Haukurth /
              <a
                href="http://en.wikipedia.org/wiki/File:The_Stranger_at_the_Door.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Jeblad /
              <a
                href="https://commons.wikimedia.org/wiki/File:Hylestad_I,_right.jpg"
                >https://commons.wikimedia.org/wiki/File:Hylestad_I,_right.jpg</a
              >&nbsp;
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2><strong>Rolandskvadet</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Sigune /
              <a
                href="http://fr.wikipedia.org/wiki/Fichier:Grandes_chroniques_Roland.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Jean Fouquet: "Bataille de Roncevaux en 778" (ca. 1455) / Yann /
              <a href="http://no.wikipedia.org/wiki/Fil:Mort_de_Roland.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              <a href="https://commons.wikimedia.org/wiki/User:Palnatoke"
                >Palnatoke</a
              >
              / https://commons.wikimedia.org/wiki/File:Roland_Kleine.jpg
            </li>
          </ol>
          <h2><strong>Snorres kongesagaer</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Christian Krohg: "Snorre Sturalson" (ca. 1890) / Jorunn /
              <a
                href="http://commons.wikimedia.org/wiki/File:Snorre_Sturluson-Christian_Krohg.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Gerhard Munthe: Illustrasjon for Olav den helliges saga i
              "Heimskringla" (ca. 1896) / Jorunn /
              <a
                href="http://commons.wikimedia.org/wiki/File:Olav_den_helliges_saga-Tittelfrise-G._Munthe.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Christian Krohg: "Kong Olav seglar i brureferd til landmerket"
              (ca. 1890) / Jorunn /
              <a
                href="http://commons.wikimedia.org/wiki/File:Olav_den_helliges_saga_CK6.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Christian Krohg: "Kong Olav lot bl&aring;se til slag" (ca. 1890) /
              Jorunn /
              <a
                href="http://commons.wikimedia.org/wiki/File:Olav_den_helliges_saga_-_Kong_Olav_lot_blaase_haerblaast_-C._Krohg.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Marius Kallhardt /
              <a
                href="http://commons.wikimedia.org/wiki/File:Norwegen_06_-_Alte_Kirche.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Fingalo /
              <a
                href="http://commons.wikimedia.org/wiki/File:Olav_der_Heilige06.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Ukjent / V&auml;sk /
              <a href="http://no.wikipedia.org/wiki/Fil:Olof_Overselo.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Amaldus Nielsen: "Morgen i Ny Hellesund" (1885) / Orland /
              <a
                href="http://commons.wikimedia.org/wiki/File:Amaldus_Nielsen_Morgen_Ny_Hellesund.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
            <li>NRK</li>
            <li>NRK</li>
            <li>NRK</li>
          </ol>
          <h2><strong>Kongespeilet</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Haabet /
              <a href="https://commons.wikimedia.org/wiki/File:Kongespeilet.jpg"
                >https://commons.wikimedia.org/wiki/File:Kongespeilet.jpg</a
              >&nbsp;
            </li>
            <li>
              Ukjent / V&auml;sk /
              <a
                href="http://sv.wikipedia.org/wiki/Fil:Bad,_en_medeltidsriddare_i_badet,_Nordisk_familjebok.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Klafui / V&auml;sk /
              <a href="http://no.wikipedia.org/wiki/Fil:Overselo_Olof04.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h2><strong>Nibelungen-eposet</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Solver /
              <a
                href="http://commons.wikimedia.org/wiki/File:Nibelungenlied2.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Howard Pyle: "The Trial of Strength" (1899) / Holt /
              <a
                href="http://commons.wikimedia.org/wiki/File:The_Trial_of_Strength_by_Howard_Pyle.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Johannes Gehrts: "Siegfrieds Tod" (1901) / Bloodofox /
              <a
                href="http://en.wikipedia.org/wiki/File:Siegfrieds_Tod_by_Johannes_Gehrts.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h2><strong>Sagaen om Gunnlaug Ormstunge</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Berig /
              <a href="http://commons.wikimedia.org/wiki/File:Vikingraad.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent /
              <a href="http://no.wikipedia.org/wiki/Fil:SigridaStorada.jpeg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Johannes Flintoe: "Egil Skallagrimsson" / Liftarn /
              <a
                href="http://en.wikipedia.org/wiki/File:Johannes-flintoe-egil-skallarimsson.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Vojtěch Krunt / Odin neboli Tom /
              <a href="http://commons.wikimedia.org/wiki/File:Viking.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Johan Peter Raadsig: "Ingolf tager Island i besiddelse" (1850) /
              Haukurth /
              <a href="http://en.wikipedia.org/wiki/File:Ingolf_by_Raadsig.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2><strong>Dekameronen</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Shakko /
              <a
                href="http://commons.wikimedia.org/wiki/File:Decamaron_intro.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Shakko /
              <a
                href="http://commons.wikimedia.org/wiki/File:Decameron_page.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>NRK</li>
          </ol>
          <h2><strong>Olav og Kari</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Codex Manesse, utsnitt / GDK /
              <a
                href="http://commons.wikimedia.org/wiki/File:Codex_Manesse_Der_von_Johansdorf.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Meister der Manessischen Liederhandschrift / Eloquence /
              <a
                href="http://commons.wikimedia.org/wiki/File:Meister_der_Manessischen_Liederhandschrift_004.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Arnstein R&oslash;nning /
              <a href="http://commons.wikimedia.org/wiki/File:Jomfru_Maria.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Liftarn /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Magnus.brostrup.landstad.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Meister der Manessischen Liederhandschrift, utsnitt / Eloquence /
              <a
                href="http://commons.wikimedia.org/wiki/File:Meister_der_Manessischen_Liederhandschrift_001.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Cfd /
              <a
                href="https://no.wikipedia.org/wiki/Fil:Norsk_Billedbog_for_b%C3%B8rn.djvu"
                >https://no.wikipedia.org/wiki/Fil:Norsk_Billedbog_for_b%C3%B8rn.djvu</a
              >&nbsp;
            </li>
            <li>
              Axel Theodor Lindahl: "Stabbur i Setesdal" (ca. 1890) / Leifern /
              <a
                href="http://commons.wikimedia.org/wiki/File:Stabbur_in_Setesdal_abt_1890.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>NRK</li>
          </ol>
          <h2><strong>Draumkvedet</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Theodor Kittelsen: "Op under Fjeldet toner en Lur" (1900)/
              <a
                href="http://en.wikipedia.org/wiki/File:Op_under_Fjeldet_toner_en_Lur.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Eug&egrave;ne Delacroix: "Dante og Vergil i helvetet" (1822) /
              Aldado /
              <a
                href="http://commons.wikimedia.org/wiki/File:Eug%C3%A8ne_Ferdinand_Victor_Delacroix_006.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>Arne Torp / DialektXperten</li>
          </ol>
          <h2><strong>Vinjeboka</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Kulturr&aring;det /
              <a
                href="https://www.kulturradet.no/vis-mowartikkel/-/1500-mow-vinjeboka"
                >https://www.kulturradet.no/vis-mowartikkel/-/1500-mow-vinjeboka</a
              >&nbsp;
            </li>
            <li>
              Ukjent / Trex /
              <a
                href="http://en.wikipedia.org/wiki/File:Sefer_raziel_segulot_sigil.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Fuzzypeg /
              <a
                href="http://commons.wikimedia.org/wiki/File:Goetia_seal_of_solomon.svg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Puck Smith /
              <a
                href="http://commons.wikimedia.org/wiki/File:Tree_of_life_bahir_hebrew.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              <a
                href="http://www.hf.uio.no/ikos/forskning/samlinger/norsk-folkeminnesamling/svartebok/bok/Jeloen.html"
                >Uio.no</a
              >&nbsp;
            </li>
          </ol>
          <h2><strong>Bergens Kapitelsbok</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Hieronymus Scholeus / Nina-no /
              <a href="http://no.wikipedia.org/wiki/Fil:Scoleus.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Fedi /
              <a
                href="http://commons.wikimedia.org/wiki/File:Scheiterhaufen_2.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Mogador /
              <a
                href="http://commons.wikimedia.org/wiki/File:Galiga%C3%AF_1617.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              HMPinnsvinet /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Absalon_Pedersson_Beyer_stone,_Vangen_kirke,_Aurland,_July_2009.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h2><strong>Den Norske Dictionarium eller Glosebog</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Christen Jensson / NRK</li>
            <li>Arild Nyb&oslash; / NRK</li>
            <li>Tom Knudsen / NDLA</li>
            <li>
              Friman /
              <a href="http://no.wikipedia.org/wiki/Fil:Primstav.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>DialektXperten</li>
            <li>DialektXperten</li>
          </ol>
          <h2><strong>Flora Danica</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Tom Knudsen / NDLA</li>
            <li>
              Ukjent / Felistoria /
              <a href="http://commons.wikimedia.org/wiki/File:Fd2665.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Johann Ernst Gunnerus / AndreasPraefcke /
              <a
                href="http://commons.wikimedia.org/wiki/File:Cicuta_virosa_Flora_Norvegica.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Erich Pontoppidan /
              <a
                href="https://commons.wikimedia.org/wiki/File:Pontoppidan_-_Norges_naturlige_historie.jpg"
                >https://commons.wikimedia.org/wiki/File:Pontoppidan_-_Norges_naturlige_historie.jpg</a
              >&nbsp;
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>NRK</li>
          </ol>
          <h2>
            <strong>Dorothe Engelbretsdotter: Sj&aelig;lens Sang-Offer</strong>
          </h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Ranveig /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Dorothe_Engelbretsdatters_Taare-Offer_1685.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Bjaespb /
              <a href="http://no.wikipedia.org/wiki/Fil:Dorothe.gif"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Carl Frithjof Smith: "Kirkeinteri&oslash;r med kvinner og barn"
              (1887) / Grev Wedels Plass Auksjoner
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2><strong>Petter Dass: Nordlands Trompet</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              John Lerli / Ranveig /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Petter_Dass_i_Melhus.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Arnstein R&oslash;nning /
              <a
                href="http://commons.wikimedia.org/wiki/File:Gabriel_Alstadhaug.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>DialektXperten</li>
          </ol>
          <h2><strong>Thomas Kingo: Kingos salmebok</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Arne List /
              <a href="http://no.wikipedia.org/wiki/Fil:Thomas_kingo.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>Tom Knudsen / NDLA</li>
            <li>
              Eric Pouhler /
              <a
                href="http://commons.wikimedia.org/wiki/File:Assomption_de_la_Vierge.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Martin Engelbrecht: "Kong frederik 5. av Danmark og Norge" (ca.
              1745) / Andreas Praefcke /
              <a
                href="http://commons.wikimedia.org/wiki/File:Martin_Engelbrecht_Frederik_5.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Mahlum /
              <a
                href="http://commons.wikimedia.org/wiki/File:Kongsberg_church_interior.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2>
            <strong>Ludvig Holberg: Niels Klims underjordiske rejse</strong>
          </h2>
          <h3>Bilder</h3>
          <ol>
            <li>Tom Knudsen / NDLA</li>
            <li>
              Ukjent / Basto /
              <a href="http://no.wikipedia.org/wiki/Fil:Nils_Klim.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Abildgaard / Clemens / P. Hansen / Saddhiyama /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Niels_klim_illustration_1789.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Galileo01 /
              <a href="http://en.wikipedia.org/wiki/File:Gullivers_travels.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Habj /
              <a
                href="http://commons.wikimedia.org/wiki/File:Ludvig_Holberg.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>DialektXperten</li>
          </ol>
          <h2><strong>Johan Herman Wessel: Wessels skrifter</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Mahlum /
              <a href="http://commons.wikimedia.org/wiki/File:Wesselstua.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              P. Hansen / Saddhiyama /
              <a
                href="http://da.wikipedia.org/wiki/Fil:Kierlighed_uden_Str%C3%B8mper_1772.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Eilif Peterssen: "En Aften i Det norske Selskab (1892) / Mahlum /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Norske_Selskab_Eilif_Peterssen.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Theodor Kittelsen: "Smeden og bageren" / Ranveig /
              <a
                href="http://commons.wikimedia.org/wiki/File:Wessel_smedbager02.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2><strong>Maurits Christoffer Hansen: Luren</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Mahlum /
              <a
                href="http://commons.wikimedia.org/wiki/File:Maurits_Hansen.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h2><strong>Henrik Wergeland: Om norsk Sprogreformation</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              O.F. Knudsen: Daguerrotypi av Henrik Wergeland (1842) / Mahlum /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Wergeland_daguerreotype.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>Tom Knudsen / NDLA</li>
            <li>
              Wilhelm Obermann: P.A. Munch / Teucer /
              <a
                href="http://no.wikipedia.org/wiki/Fil:P_A_Munch_(engraving_by_W_Obermann).jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Henrik Wergeland /
              <a
                href="http://www.arkivverket.no/webfelles/Skattkammeret/wergeland/index.html"
                >Arkivverket.no</a
              >
            </li>
            <li>
              <a
                href="http://www.arkivverket.no/webfelles/Skattkammeret/wergeland/index.html"
                >Arkivverket.no</a
              >
            </li>
            <li>
              Carl Peter Lehmann: Portrett av Amalie Sofie Bekkevold / Orland /
              <a
                href="http://nn.wikipedia.org/wiki/Fil:Amalie_Sofie_Bekkevold.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Helge H&oslash;if&oslash;dt / Helge H&oslash;if&oslash;dt /
              <a
                href="http://nn.wikipedia.org/wiki/Fil:Wergelands_kontor_Akershus.JPG"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Christian Olsen: "Henrik Wergeland p&aring; sykeleiet" (1844) /
              Ranveg /
              <a
                href="https://commons.wikimedia.org/wiki/File:Wergeland_sykeleie.jpg"
                >https://commons.wikimedia.org/wiki/File:Wergeland_sykeleie.jpg</a
              >&nbsp;
            </li>
            <li>O. V&aelig;ring / Nasjonalbiblioteket&nbsp;</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>NRK</li>
            <li>NRK</li>
          </ol>
          <h2>
            <strong>Asbj&oslash;rnsen og Moe: Norske folkeeventyr</strong>
          </h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Theodor Kittelsen: "Soria Moria" (1900) /Lipothymia /
              <a
                href="http://commons.wikimedia.org/wiki/File:Theodor_Kittelsen,_Soria_Moria.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Den fj&auml;ttrade ankan /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Peter_Christen_Asbj%C3%B6rnsen_(ur_Svenska_Familj-Journalen).png"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Adolf Closs: tresnitt etter foto av Fr. Klem / Jorunn /
              <a href="http://en.wikipedia.org/wiki/File:J%C3%B8rgen_Moe.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Theodor Kittelsen: "Gudbrand i Lia" (1907) / Jorunn /
              <a
                href="http://commons.wikimedia.org/wiki/File:Gudbrand_i_Lia.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Theodor Kittelsen: "Kvitebj&oslash;rn kong Valemon" / And osl /
              <a href="http://commons.wikimedia.org/wiki/File:Kvitebjorn.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Theodor Kittelsen: "N&oslash;kken" / Dagny /
              <a
                href="http://commons.wikimedia.org/wiki/File:Nokken_av_Theodor_Kittelsen.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Theodor Kittelsen: "Fugl Dam" / Jorunn /
              <a href="http://commons.wikimedia.org/wiki/File:Fugl_Dam_1.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Alf Hartvig og Chr. Danielsen / Jorunn /
              <a
                href="http://en.wikipedia.org/wiki/File:Norske_folke_og_huldre-eventyr.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>Ellen Kalvenes / Kristin Eriksen Vold / NDLA</li>
            <li>NRK</li>
          </ol>
          <h2><strong>Johan Sebastian Welhaven: Nyere Digte</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Johan Sebastian Welhaven: Selvportrett (ca. 1825) / Ranveig /
              <a
                href="http://commons.wikimedia.org/wiki/File:Johan_Sebastian_Welhaven.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Johan Sebastian Welhaven: "Soiree-billeder" (1866) / Orland /
              <a
                href="http://commons.wikimedia.org/wiki/File:Welhaven_Soireebilleder.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent (ca. 1835-40) / Orland /
              <a href="http://no.wikipedia.org/wiki/Fil:Ida_kierulf.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2><strong>Bj&oslash;rnstjerne Bj&oslash;rnson: Faderen</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Karl Anderson (1904) / K&aring;re-Olav /
              <a
                href="http://commons.wikimedia.org/wiki/File:Bj%C3%B8rnstjerne_Bj%C3%B8rnson_by_Karl_Anderson_1904.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              K&aring;re-Olav /
              <a
                href="https://commons.wikimedia.org/wiki/File:Bj%C3%B8rnstjerne_Bj%C3%B8rnson_signature.png"
                >https://commons.wikimedia.org/wiki/File:Bj%C3%B8rnstjerne_Bj%C3%B8rnson_signature.png</a
              >&nbsp;
            </li>
            <li>
              Anders Beer Wilse (1910) / Manxruler /
              <a
                href="http://commons.wikimedia.org/wiki/File:Bj%C3%B8rnstjerne_Bj%C3%B8rnson_on_board_Norge.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Hans Gude: "Den gamle Sneplov Ved Skovkanten" (1893) / EdvardIsle
              /
              <a
                href="http://commons.wikimedia.org/wiki/File:Hans_Gude_-_Den_gamle_Sneplov_Ved_Skovkanten_(1893).jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              <a
                href="http://www.nb.no/bjornson/bjoernsons-beste/dikt-og-sanger/dikt-og-sanger/kom-bukken-til-gutten-lokkelek"
                >Nasjonalbiblioteket</a
              >
            </li>
            <li>
              Gerhard Munthe: "Bj&oslash;rgan i Kvikne" / K&aring;re-Olav /
              <a
                href="http://en.wikipedia.org/wiki/File:Bj%C3%B8rgan_by_Gerhard-Munthe.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Benjamin Gimmel / BenHur /
              <a
                href="http://commons.wikimedia.org/wiki/File:Bl%C3%BChender_Kirschbaum_im_Fr%C3%BChling.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Kristian Krohg: "Bj&oslash;rnstjerne Bj&oslash;rnson taler ved
              Fridtjof Nansens hjemkost 13. september 1896" (1896) /
              K&aring;re-Olav /
              <a
                href="http://en.wikipedia.org/wiki/File:Bj%C3%B8rnson_speaking_1896_by_Christian_Krohg.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              P.S. Kr&oslash;yer: "Middagsbordet p&aring; Aulestad" (1901) /
              K&aring;re-Olav /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Dinner_at_Aulestad_by_P_S_Kr%C3%B8yer.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Frode H. Korneliussen / Frokor /
              <a
                href="http://commons.wikimedia.org/wiki/File:Ja,_vi_elsker-memorial.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>NRK</li>
          </ol>
          <h2><strong>Ivar Aasen: Det norske Folkesprogs Grammatik</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Carl Christian Wischmann (1881) / Mahlum /
              <a
                href="http://commons.wikimedia.org/wiki/File:Aasen_Wischmann_1881.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Mahlum /
              <a
                href="http://commons.wikimedia.org/wiki/File:Det_norske_Folkesprogs_Grammatik_tittelside.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              H. Uthuslien (1891) / Mahlum //
              <a
                href="http://commons.wikimedia.org/wiki/File:Uthuslien_Aasen_1891.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ivar Aasen / Teucer /
              <a
                href="http://commons.wikimedia.org/wiki/File:Ivar_Aasen_signature.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Chris Nyborg / Cnyborg /
              <a
                href="http://commons.wikimedia.org/wiki/File:VFG_IvarAasen01.JPG"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
            <li>NRK Skole</li>
          </ol>
          <h2><strong>Camilla Collett: Amtmandens D&oslash;ttre</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Nicolai Wergeland / Orland /
              <a
                href="http://commons.wikimedia.org/wiki/File:Camilla_Collett_by_Nicolai_Wergeland.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Johan G&oslash;rbitz (1839) / Orland /
              <a
                href="http://commons.wikimedia.org/wiki/File:Camilla_Collett_1839.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Julius Schmid: "Schubertiade" (1897), utsnitt / AndreasPraefcke /
              <a
                href="http://commons.wikimedia.org/wiki/File:Julius_Schmid_Schubertiade_Detail.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Currier &amp; Ives: "The Age of Iron. Man as he Expects to be"
              (1869) / Churchh /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Age-of-Iron_Man-as-he-Expects-to-Be_1869.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Chris Nyborg / Cnyborg /
              <a
                href="http://commons.wikimedia.org/wiki/File:VFG_CamillaCollett01.JPG"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
          </ol>
          <h2><strong>Aasmund Olavsson Vinje: D&oslash;len</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Mahlum /
              <a href="http://commons.wikimedia.org/wiki/File:Vinje.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Andrva /
              <a href="http://commons.wikimedia.org/wiki/File:Vinjeibergen.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Andrva /
              <a
                href="http://commons.wikimedia.org/wiki/File:Vinje_i_vikingen.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              H&aring;kon Thingstad /
              <a
                href="http://commons.wikimedia.org/wiki/File:61.3912_N,_8.2565_E.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Theodor Kittelsen (ca. 1907) / Jorunn /
              <a
                href="http://commons.wikimedia.org/wiki/File:Kjetta_som_var_s%C3%A5_f%C3%A6l_til_%C3%A5_ete_1.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Sverdrup /
              <a
                href="http://commons.wikimedia.org/wiki/File:Rondane-Tmarking.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Theodor Kittelsen (1907) / Jorunn /
              <a
                href="http://commons.wikimedia.org/wiki/File:De_tolv_villender_3.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Theodor Kittelsen (1907) / Orland /
              <a
                href="http://commons.wikimedia.org/wiki/File:Vinjefurua_kittelsen.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Ordensherre /
              <a
                href="http://commons.wikimedia.org/wiki/File:Skilling-Magazin_1891.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>Nils Erik Kvamme / NDLA</li>
            <li>Nils Erik Kvamme / NDLA</li>
          </ol>
          <h2><strong>Knud Knudsen: Unorsk og norsk</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Rart /
              <a href="http://no.wikipedia.org/wiki/Fil:Knudknudsen.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Karl Ragnar Gjertsen / Krg /
              <a href="http://no.wikipedia.org/wiki/Fil:Hesthaghuset.JPG"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h2><strong>Alexander Kielland: Gift</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Kjetil r /
              <a href="http://sv.wikipedia.org/wiki/Fil:Kielkopi.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Saddhiyama /
              <a
                href="http://en.wikipedia.org/wiki/File:Hovedstr%C3%B8minger_1872.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Hersfold /
              <a
                href="http://commons.wikimedia.org/wiki/File:Fredericka_Mendelbaum2.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Haabet /
              <a
                href="http://commons.wikimedia.org/wiki/File:ISkolenV%C3%A6ggelus_paaFyn.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Haabet /
              <a
                href="http://commons.wikimedia.org/wiki/File:Afkoelet_skinsy.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Haabet /
              <a
                href="http://commons.wikimedia.org/wiki/File:Pantelaaneren1890.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h2><strong>Arne Garborg: Mannfolk</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Ranveig /
              <a
                href="http://commons.wikimedia.org/wiki/File:Garborg_student_1875.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Gunleiv Hadland / Gunnernett /
              <a
                href="http://commons.wikimedia.org/wiki/File:House_at_J%C3%A6ren_in_Norway_Garborgheimen.JPG"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Ranveig /
              <a
                href="http://commons.wikimedia.org/wiki/File:Garborg_portrett.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Chr. Krogh: "Albertine i politil&aelig;gens ventev&aelig;relse"
              (1887) / Eikern /
              <a
                href="http://commons.wikimedia.org/wiki/File:Christian_Krogh-Albertine_i_politil%C3%A6gens_ventev%C3%A6relse2.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Anders Beer Wilse / Manxruler /
              <a
                href="http://commons.wikimedia.org/wiki/File:Arne_and_Hulda_Garborg_1910.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Jarle Vines / Jarvin /
              <a href="http://commons.wikimedia.org/wiki/File:Knudaheio2.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Onar Vikingstad / Roarjo /
              <a href="https://commons.wikimedia.org/wiki/File:Knudaheio.jpg"
                >https://commons.wikimedia.org/wiki/File:Knudaheio.jpg</a
              >&nbsp;
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>Nils Erik Kvamme / NDLA</li>
          </ol>
          <h2><strong>Norsk Billedbog for B&oslash;rn</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Maria Giovanni Cl&eacute;menti: "Enfants de Charles-Emmanuel III"
              (1731) / Odejea /
              <a
                href="http://en.wikipedia.org/wiki/File:Enfants_de_Charles-Emmanuel_III.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Theodor Kittelsen: "En uheldig bj&oslash;rnejakt" (1908) / Masur /
              <a
                href="http://en.wikipedia.org/wiki/File:Theodor_Kittelsen-En_uheldig_bj%C3%B8rnejakt.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              t.o.m 12.
              <a href="https://no.wikipedia.org/wiki/Eivind_Nielsen"
                >Eivind Nielsen</a
              >
              / Cfd /
              <a
                href="https://no.wikipedia.org/w/index.php?title=Fil%3ANorsk_Billedbog_for_b%C3%B8rn.djvu&amp;page=1"
                >https://no.wikipedia.org/w/index.php?title=Fil%3ANorsk_Billedbog_for_b%C3%B8rn.djvu&amp;page=1</a
              >&nbsp;
            </li>
            <li value="13">
              J.E. Friedberg / Andreas Praefcke /
              <a
                href="http://commons.wikimedia.org/wiki/File:Friedberg_ABC-Buch.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>Kvensk institutt</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>Morten R&oslash;hrt / NDLA</li>
            <li>Terje Aronsen / DialektXperten</li>
          </ol>
          <h2><strong>Henrik Ibsen: Hedda Gabler</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>
              Kristoffer &Oslash;verli Andersen / VG / Scanpix / CC BY-NC-SA
            </li>
            <li>Heiko Junge / Scanpix / CC BY-NC-SA</li>
            <li>Lise &Aring;serud / Scanpix / CC BY-NC-SA</li>
            <li>Tor G. Stenersen / Scanpix / CC BY-NC-SA</li>
            <li>Jarl Fr. Erichsen / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h2><strong>Vilhelm Krag: Digte</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Gustav Vigeland: "Vilhelm Krag" (ca 1960) / &copy; Vigeland-museet
              / BONO 2010 / Foto: Oddvar Engan
            </li>
            <li>Anders Beer Wilse / Norsk Folkemuseum</li>
            <li>
              Ukjent / 91 /
              <a
                href="http://commons.wikimedia.org/wiki/File:Havbukta_-_Ny-Hellesund.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Franz von Stuck: "Salome" (1906) / AndreasPraefcke /
              <a
                href="http://commons.wikimedia.org/wiki/File:Franz_von_Stuck_010.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Gustav Klimt: "Kysset" (ca 1907), utsnitt / Erudito234 /
              <a
                href="http://commons.wikimedia.org/wiki/File:El_beso(Gustav_Klimt)_.jpg?uselang=nb"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Fernand Khnopff: "Kj&aelig;rtegn" (1898) / Eloquence /
              <a
                href="http://commons.wikimedia.org/wiki/File:Fernand_Khnopff_002.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Franz von Bayros: "Le jardin d'Aphrodite" (ca 1907) / ~Pyb /
              <a
                href="http://commons.wikimedia.org/wiki/File:Franz_von_Bayros_032.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Edvard Munch: "Skrik" (1893) / &copy; Munch-museet /
              Munch-Ellingsen gruppen / BONO 2010
            </li>
            <li>
              Amaldus Nielsen: "Morgen i Ny Hellesund" (1885) / Orland /
              <a
                href="http://commons.wikimedia.org/wiki/File:Amaldus_Nielsen_Morgen_Ny_Hellesund.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>Morten R&oslash;hrt / Amendor / NDLA</li>
          </ol>
          <h2><strong>Amalie Skram: Forr&aring;dt</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / ThorRune /
              <a href="http://en.wikipedia.org/wiki/File:Amalie_Skram.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Leopold Reutlinger (1890) / Max Rebo Band /
              <a
                href="http://commons.wikimedia.org/wiki/File:1890_Leopold_Reutlinger_nude_photograph.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Anders Beer Wilse /
              <a
                href="http://www.nb.no/cgi-bin/galnor/gn_sok.sh?id=101171&amp;skjema=2&amp;fm=4"
                >Norsk Folkemuseum</a
              >
            </li>
            <li>
              Anders Beer Wilse /
              <a
                href="http://www.nb.no/cgi-bin/galnor/gn_sok.sh?id=63012&amp;skjema=2&amp;fm=4"
                >Norsk Folkemuseum</a
              >
            </li>
            <li>
              Haabet /
              <a
                href="http://commons.wikimedia.org/wiki/File:Beroligende2taender.jpg"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
          </ol>
          <h2><strong>Knut Hamsun: Pan</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Alfredo Andersen (1891) / Orland /
              <a
                href="http://commons.wikimedia.org/wiki/File:Knut_Hamsun_painting_by_Alfredo_Andersen_(1860-1935).jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Lipothymia /
              <a
                href="http://commons.wikimedia.org/wiki/File:Knut_Hamsun_in_Chicago,_1884.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>
              Anders Beer Wilse / kjetil_r /
              <a
                href="http://commons.wikimedia.org/wiki/File:Hamsun_bldsa_HA0249.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Eilif Peterssen: Jeger i skogen ved Ask (1884) / Ranveig /
              <a
                href="http://nl.wikipedia.org/wiki/Bestand:Eilif_Peterssen-Jeger_i_skogen_ved_Ask_1884.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Finn Rindahl / Finnrind /
              <a
                href="http://en.wikipedia.org/wiki/File:V%C3%A5gakaillen_nattlys.JPG"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Eilif Peterssen: Laksefiskeren (1889) / Ranveig /
              <a
                href="http://en.wikipedia.org/wiki/File:Eilif_Peterssen-Laksefiskeren_(1889).jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Nikolai Astrup: V&aring;rnatt i hagen (1909) / Ranveig /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Nikolai_Astrup-V%C3%A5rnatt_i_hagen-1909.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
            <li>Ragnhild Wigdahl</li>
          </ol>
          <h2><strong>Sigbj&oslash;rn Obstfelder: Byen</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Oda Krogh / K&aring;re-Olav /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Sigbj%C3%B8rn_Obstfelder_by_Oda_Krohg.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / V85 /
              <a
                href="http://commons.wikimedia.org/w/index.php?title=File:De_r%C3%B8de_dr%C3%A5ber.djvu&amp;page=1"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / V85 /
              <a
                href="https://commons.wikimedia.org/w/index.php?title=File:Obstfelder_-_Melodier.djvu&amp;page=3"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Gustave Courbet / Bot /
              <a
                href="http://en.wikipedia.org/wiki/File:Gustave_Courbet_033.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Edvard Munch: Aften p&aring; Karl Johan (1892) / &copy;
              Munch-museet / Munch-Ellingsen gruppen / BONO 2010
            </li>
            <li>
              Anders Beer Wilse /
              <a
                href="http://www.nb.no/cgi-bin/galnor/gn_sok.sh?id=44987&amp;skjema=2&amp;fm=4"
                >Norsk Folkemuseum</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>Morten R&oslash;hrt / NDLA</li>
            <li>Morten R&oslash;hrt / NDLA</li>
          </ol>
          <h2><strong>Rasmus L&oslash;land: Kvitebj&oslash;rnen</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              B&aring;rd L&oslash;ken / Samfoto / NTB Scanpix / CC
              BY-NC-SA&nbsp;
            </li>
            <li>
              Ukjent /
              <a
                href="http://www.forfattarnett.no/rasmusloland/index.php?option=com_wrapper&amp;view=wrapper&amp;Itemid=100132"
                >Forfattarnett.no</a
              >&nbsp;
            </li>
            <li>
              Ukjent /
              <a
                href="http://www.forfattarnett.no/rasmusloland/index.php?option=com_wrapper&amp;view=wrapper&amp;Itemid=100132"
                >Forfattarnett.no</a
              >&nbsp;
            </li>
          </ol>
          <h2><strong>&Oslash;vre Richter Frich: Jonas Fjeld</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Gustav Wentzel: Frokost II / Morgenstemning (1885) / Orland /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Gustav_Wentzel_Frokost_2.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Yomangani /
              <a href="http://en.wikipedia.org/wiki/File:Corder-broadside.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              <a href="http://universitas.uio.no/Arkiv/1997/19/kultur1.html"
                >Ukjent</a
              >
              /
              <a href="https://universitas.no/Arkiv/1997/19/kultur1.html/"
                >https://universitas.no/Arkiv/1997/19/kultur1.html/</a
              >&nbsp;
            </li>
            <li>
              <a
                href="http://www.nb.no/utlevering/contentview.jsf?urn=URN:NBN:no-nb_digibok_2009042000107"
                >NBDigital</a
              >&nbsp;
            </li>
            <li>
              <a
                href="http://www.nb.no/utlevering/nb/0a95d2c150ff96bc55825dceda8b2f39#&amp;struct=DIV400"
                >NBDigital</a
              >
            </li>
            <li>
              Sidney Paget / Mschlindwein /
              <a href="http://en.wikipedia.org/wiki/File:Paget_holmes.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Bj&oslash;rn Sigurds&oslash;n / Scanpix / CC BY-NC-SA</li>
            <li>Terje H.T. Andersen / Aftenposten / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h2><strong>Sigrid Undset: Kristin Lavransdatter</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Sandivas /
              <a
                href="http://commons.wikimedia.org/wiki/File:Sigrid_Undset_young.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Ukjent / Roede /
              <a href="http://en.wikipedia.org/wiki/File:Oscar1888.jpg"
                >Wikimedia Commons</a
              >
              (utsnitt)
            </li>
            <li>
              Nobelstiftelsen / September9 /
              <a
                href="http://commons.wikimedia.org/wiki/File:Sigrid_Undset_1928.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Avilde Torp / Sandivas /
              <a
                href="http://commons.wikimedia.org/wiki/File:Sigrid_Undset_at_Bjerkeb%C3%A6k.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Geir Olsen / VG /
              <a href="http://www.scanpix.no/">Scanpix / CC BY-NC-SA</a>
            </li>
            <li>
              Ukjent / Leinad-Z /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Conversation-saints_01.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Jun Kwang Han / Jorunn /
              <a
                href="http://nl.wikipedia.org/wiki/Bestand:Heddal_stavkyrkje_antemesalet.jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
            <li>NRK Skole</li>
            <li>NRK Skole</li>
          </ol>
          <h2>
            <strong>Johan Falkberget: B&oslash;r B&oslash;rson jr.</strong>
          </h2>
          <h3>Bilder</h3>
          <ol>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Ned Alley / Scanpix / CC BY-NC-SA</li>
            <li>
              Mahlum /
              <a href="http://commons.wikimedia.org/wiki/File:Hyttklokka.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>Erik Thorberg / NTB / Scanpix / CC BY-NC-SA</li>
            <li>Berit Roald / Scanpix / CC BY-NC-SA</li>
            <li>
              Jeblad /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Lars_Endre_Strand_som_B%C3%B8r_B%C3%B8rson_Jr_i_%C2%ABB%C3%B8r_B%C3%B8rson_Jr%C2%BB.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Sverre A. B&oslash;rretzen / Aktuell / Scanpix / NTB / CC BY-NC
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2><strong>Rudolf Nilsen: P&aring; stengrunn</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>
              Ingvald M&oslash;llerstad / Aftenposten / Scanpix / CC BY-NC-SA
            </li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>
              <a href="https://commons.wikimedia.org/wiki/User:Toresetre"
                >Tore S&aelig;tre</a
              >
              /
              <a
                href="https://commons.wikimedia.org/wiki/File:Lars_Klevstrand_Cosmopolite_(001516).jpg"
                >https://commons.wikimedia.org/wiki/File:Lars_Klevstrand_Cosmopolite_(001516).jpg</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2><strong>Olav Duun: Medmenneske</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Anders Beer Wilse /
              <a
                href="http://www.nb.no/cgi-bin/galnor/gn_sok.sh?id=66447&amp;skjema=2&amp;fm=4"
                >Norsk Folkemuseum</a
              >
            </li>
            <li>
              Knut Baade: Stormnatt (1879) / GlaDooo /
              <a
                href="http://commons.wikimedia.org/wiki/File:Knut_Baade_(Stormnatt).jpg"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h2><strong>Halldis Moren Vesaas: Harpe og dolk</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Orland /
              <a
                href="http://no.wikipedia.org/wiki/Fil:Halldis_Moren_Vesaas.png"
                >Wikimedia Commons</a
              >
            </li>
            <li>Erik Johansen / Scanpix / CC BY-NC-SA</li>
            <li>Rolf Chr. Ulrichsen / Aftenposten / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>Unn Vibeke Hol / NDLA</li>
            <li>Unn Vibeke Hol / NDLA</li>
          </ol>
          <h2>
            <strong>Aksel Sandemose: En flyktning krysser sitt spor</strong>
          </h2>
          <h3>Bilder</h3>
          <ol>
            <li>Bj&oslash;rn Fj&oslash;rtoft / Scanpix / CC BY-NC-SA</li>
            <li>Morten Holm / Scanpix / CC BY-NC-SA</li>
            <li>
              Ian Woodward / Triton /
              <a href="http://no.wikipedia.org/wiki/Fil:Loup_garou.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Aage Storl&oslash;kken / Aktuell /
              <a href="http://www.scanpix.no/">Scanpix / CC BY-NC-SA</a>
            </li>
          </ol>
          <h2><strong>Nordahl Grieg: Til ungdommen</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>NRK</li>
            <li>Odd Nicolaysen / Aktuell / Scanpix / CC BY-NC-SA</li>
            <li>
              Ukjent / Manxruler /
              <a href="http://no.wikipedia.org/wiki/Fil:Nordahl_Grieg.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Deutsches Bundesarchiv /
              <a
                href="http://commons.wikimedia.org/wiki/File:Bundesarchiv_Bild_183-17036-0005,_Spanischer_B%C3%BCrgerkrieg,_Nordahl_Grieg,_Ludwig_Renn.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>NRK</li>
          </ol>
          <h2><strong>Rolf Jacobsen: Jord og jern</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Jon Hauge / Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Jon Eeg / NTB / Scanpix / CC BY-NC-SA</li>
            <li>Helge Sunde / Samfoto / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>NRK Skole</li>
            <li>NRK Skole</li>
          </ol>
          <h2>
            <strong>Arnulf &Oslash;verland: Den r&oslash;de front</strong>
          </h2>
          <h3>Bilder</h3>
          <ol>
            <li>Aage Storl&oslash;kken / Aktuell / Scanpix / CC BY-NC-SA</li>
            <li>Aage Storl&oslash;kken / Aktuell / Scanpix / CC BY-NC-SA</li>
            <li>Novosti / Scanpix / CC BY-NC-SA</li>
            <li>Arnd Wiegmann / Reuters / Scanpix / CC BY-NC-SA</li>
            <li>
              Ingvald M&oslash;llerstad / Aftenposten / Scanpix / CC BY-NC-SA
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2><strong>Stortingsmelding nr. 31</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Rune Petter N&aelig;ss / NTB / CC BY-NC</li>
            <li>
              H.tjerns /
              <a
                href="http://en.wikipedia.org/wiki/File:Stiklestad_kirke_-_vinter.JPG"
                >Wikimedia Commons</a
              >&nbsp;
            </li>
            <li>
              Ukjent / Ranveig /
              <a
                href="http://commons.wikimedia.org/wiki/File:Garborg_portrett.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Sverre A. B&oslash;rretzen / Aktuell / Scanpix / CC BY-NC-SA
            </li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Espen Bratlie / Samfoto / NTB / CC BY-NC</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Ukjent</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Oddvar Walle Jensen / NTB / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
          </ol>
          <h2><strong>Vangsgutane</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Ukjent / Mahlum /
              <a href="http://no.wikipedia.org/wiki/Fil:Norskt_Barneblad.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>
              Olve Utne /
              <a
                href="http://lokalhistoriewiki.no/index.php/Bilde:7481cr_Tuss_og_Troll.jpg"
                >Lokalhistoriewiki.n0</a
              >
            </li>
            <li>Tor Richardsen / Scanpix / CC BY-NC-SA</li>
            <li>Erlend Aas / Scanpix / NTB / CC BY-NC</li>
            <li>
              Leif Halse / Fonna forlag /
              <a href="http://www.nrk.no/nyheter/kultur/litteratur/1.6912031"
                >NRK</a
              >
            </li>
            <li>
              Jens R. Nilssen /
              <a href="http://www.nrk.no/nyheter/kultur/litteratur/1.6912031"
                >NRK</a
              >
            </li>
            <li>
              Kristin Rivrud /
              <a href="http://www.nrk.no/nyheter/distrikt/ostafjells/1.4126790"
                >NRK</a
              >
            </li>
            <li>
              Andreasv /
              <a href="http://nn.wikipedia.org/wiki/Fil:Sm%C3%B8rbukk2.jpg"
                >Wikimedia Commons</a
              >
            </li>
            <li>Lise &Aring;serud / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
          </ol>
          <h2><strong>Inger Johanne Hagerup: Videre</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Aage Storl&oslash;kken / Aktuell / Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>
              Ingvald M&oslash;llerstad / Aftenposten / Scanpix / CC BY-NC-SA
            </li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>Ivar Aaserud / Aktuell / Scanpix / CC BY-NC-SA</li>
            <li>Marius Knutsen / VG / Scanpix / CC BY-NC-SA</li>
            <li>Arne Tjensvold / Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>Erik Thorberg / NTB / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>Unn Vibeke Hol / NDLA</li>
            <li>Unn Vibeke Hol / NDLA</li>
          </ol>
          <h2><strong>Tarjei Vesaas: Is-slottet</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Novosti / Scanpix / CC BY-NC-SA</li>
            <li>Rolf Chr. Ulrichsen / Aftenposten /Scanpix / CC BY-NC-SA</li>
            <li>Thor Nielsen / VG / Scanpix / CC BY-NC-SA</li>
            <li>
              Sverre A. B&oslash;rretzen / Aktuell / Scanpix / CC BY-NC-SA
            </li>
            <li>Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>Scanpix / CC BY-NC-SA</li>
            <li>
              Signe Marie Kittelsaa / Orland /
              <a href="http://commons.wikimedia.org/wiki/File:Midtbo3.JPG"
                >Wikimedia Commons</a
              >
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>NRK Skole</li>
            <li>Unn Vibeke Hol / NDLA</li>
            <li>Unn Vibeke Hol / NDLA</li>
          </ol>
          <h2><strong>Olav H. Hauge: Dropar i austavind</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Posten Norge / Scanpix / CC BY-NC-SA</li>
            <li>Line M&oslash;ller / VG / Scanpix / CC BY-NC-SA</li>
            <li>NRK</li>
          </ol> 
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK&nbsp;</li>
          </ol>
          <h2><strong>Kjartan Fl&oslash;gstad: Dalen Portland</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Rolf M. Aagaard / Aftenposten / Scanpix</li>
            <li>Kyrre Lien / Scanpix / CC BY-NC-SA</li>
            <li>Helge Sunde / Samfoto / Scanpix&nbsp;</li>
            <li>Arild Hinna / VG / Scanpix / CC BY-NC-SA</li>
            <li>Bernt Eide / Samfoto / Scanpix</li>
            <li>Luca Kleve-Ruud / Samfoto / Scanpix</li>
          </ol>
          <h2>
            <strong>Jan Erik Vold: Mor Godhjertas glade versjon. Ja</strong>
          </h2>
          <h3>Bilder</h3>
          <ol>
            <li>Olav Olsen / Aftenposten / Scanpix</li>
            <li>NTB / Scanpix / CC BY-NC-SA</li>
            <li>Stig N&aelig;ss / VG / Scanpix / CC BY-NC-SA</li>
            <li>Bj&oslash;rn Aslaksen / VG / Scanpix / CC BY-NC-SA</li>
            <li>
              Fra Jan Erik Volds diktsamling
              <em>Mellom speil og speil</em> (1965):
              <a
                href="https://www.nb.no/items/URN:NBN:no-nb_digibok_2007052304008?page=17"
                >https://www.nb.no/items/URN:NBN:no-nb_digibok_2007052304008?page=17</a
              >
            </li>
            <li>
              Alf &Oslash;ystein St&oslash;tvig / VG / Scanpix / CC BY-NC-SA
            </li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
            <li>NRK</li>
          </ol>
          <h2><strong>Jan Kj&aelig;rstad: Forf&oslash;reren</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              <a href="https://commons.wikimedia.org/wiki/User:Bep"
                >Bj&oslash;rn Erik Pedersen</a
              >
              /
              <a
                href="https://commons.wikimedia.org/wiki/File:Jan_Kj%C3%A6rstad_Oslo_bokfestival_2011.jpg"
                >https://commons.wikimedia.org/wiki/File:Jan_Kj%C3%A6rstad_Oslo_bokfestival_2011.jpg</a
              >&nbsp;
            </li>
            <li>Jan Petter Lynau / VG / Scanpix / CC BY-NC-SA</li>
            <li>Trond Solberg / VG / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
            <li>NRK</li>
            <li>NRK Skole</li>
          </ol>
          <h2><strong>Erlend Loe: Naiv.Super</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Lise &Aring;serud / NTB / Scanpix / CC BY-NC-SA</li>
            <li>Jon-Are Berg-Jcobsen / Scanpix / CC BY-NC-SA&nbsp;</li>
            <li>Terje Bendiksby / NTB / CC BY-NC</li>
            <li>NRK</li>
            <li>Erlend Aas / NTB / Scanpix / CC BY-NC-SA</li>
            <li>Roy Mangersnes / Samfoto / Scanpix / CC BY-NC-SA</li>
            <li>Tor G. Stenersen / Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>Bj&oslash;rn Reese / VG / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole</li>
            <li>NRK Skole</li>
          </ol>
          <h2><strong>Jon Fosse: Nokon kjem til &aring; komme</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Tom A. Kolstad / Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>B&aring;rd L&oslash;ken / Samfoto / Scanpix / CC BY-NC-SA</li>
            <li>Eggert J&oacute;hannesson / NTB / CC BY-NC-SA</li>
            <li>Tom A. Kolstad / Aftenposten / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2><strong>Hanne &Oslash;rstavik: Kj&aelig;rlighet</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Berit Roald / NTB / Scanpix / CC BY-NC-SA</li>
            <li>Oktober forlag</li>
            <li>Bobbi Dombrowski / stock.xchng</li>
            <li>H&aring;kon Mosvold Larsen / NTB / Scanpix / CC BY-NC-SA</li>
            <li>Rolf M. Aagaard / Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>Berit Roald / NTB / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2><strong>Shabana Rehman: Mullal&oslash;ft</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Tom-Egil Jensen / VG / Scanpix / CC BY-NC-SA</li>
            <li>
              &Aring;shild Barkved St&oslash;ylen / VG / Scanpix / CC BY-NC-SA
            </li>
            <li>Linda N&aelig;sfeldt / VG / Scanpix / CC BY-NC-SA</li>
            <li>&Oslash;yvind S&aelig;tre / VG / Scanpix / CC BY-NC-SA</li>
            <li>Paul Sigve Amundsen / VG / Scanpix / CC BY-NC-SA</li>
            <li>Annemor Larsen / VG / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
            <li>NRK</li>
          </ol>
          <h2><strong>&Aring;sne Seierstad: Bokhandleren i Kabul</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>
              Luca Kleve-Ruud / Samfoto Dagsavisen / Scanpix / CC BY-NC-SA
            </li>
            <li>Thomas Bj&ouml;rnflaten / TT / Scanpix / CC BY-NC-SA</li>
            <li>Terje Bendiksby / NTB / Scanpix / CC BY-NC-SA</li>
            <li>Tor Arne Andreassen / Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>Tor Arne Andreassen / Aftenposten / Scanpix / CC BY-NC-SA</li>
            <li>Kjell Odegard / TT / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK</li>
          </ol>
          <h2><strong>Karl Ove Knausg&aring;rd: Min kamp</strong></h2>
          <h3>Bilder</h3>
          <ol>
            <li>Daniel Nilsson / TT / Scanpix / CC BY-NC-SA</li>
            <li>Terje Mortensen / VG / Scanpix / CC BY-NC-SA</li>
            <li>Yngve Knausg&aring;rd / Forlaget Oktober&nbsp;</li>
            <li>Eivind Griffith Br&aelig;nde / VG / Scanpix / CC BY-NC-SA</li>
            <li>
              <a href="https://commons.wikimedia.org/wiki/User:FrankieF"
                >Frankie Fouganthin</a
              >
              /
              <a
                href="https://commons.wikimedia.org/wiki/File:Linda_Bostr%C3%B6m_Knausg%C3%A5rd_okt_2016.jpg"
                >https://commons.wikimedia.org/wiki/File:Linda_Bostr%C3%B6m_Knausg%C3%A5rd_okt_2016.jpg</a
              >&nbsp;
            </li>
            <li>Daniel Nilsson / TT / Scanpix / CC BY-NC-SA</li>
            <li>Aktuell / Scanpix / CC BY-NC-SA</li>
            <li>Daniel Nilsson / Scanpix / CC BY-NC-SA</li>
          </ol>
          <h3>Video og lyd</h3>
          <ol>
            <li>NRK Skole&nbsp;</li>
            <li>NRK</li>
            <li>NRK Skole</li>
          </ol>

          <button
            class="btn_back"
            @click="$router.push(`/${globalVars.langCode}`)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              width="24"
            >
              <path
                d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13h30v-2z"
              />
            </svg>

            <div>{{ $t("general.pageBookBackButton") }}</div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonBackArrow from "@/components/ButtonBackArrow";

export default {
  name: "CopyrightNB",
  components: {
    ButtonBackArrow,
  },
  inject: ["globalVars"],
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
